import React from "react";
import { PickupCargoInternodeRouteBinsDataInterface } from "../../../../redux/interfaces/raports.interface";

import { getDateAndTime } from "../../../../utils/dateAndTime";
import { useAppDispatch } from "../../../../redux/hooks";
import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import {
  openClosePackageCargoInternodeRouteModal,
  setSelectedCargoInternodeItemForClosing,
} from "../../../../redux/reducer/raports.reducer";

function BinsTable({
  bins,
}: {
  bins: PickupCargoInternodeRouteBinsDataInterface[];
}) {
  const dispatch = useAppDispatch();

  const BinStatusesValues = [
    { value: 0, label: "BIN creat" },
    { value: 1, label: "BIN scanat in masina" },
    { value: 2, label: "BIN scanat in nod" },
    { value: 3, label: "BIN golit cu neconformitati" },
    { value: 4, label: "BIN golit fara neconformmitati" },
  ];

  const getStatusLabelForBin = (status: number) => {
    const getStatus = BinStatusesValues.find((s) => s.value === status);

    return getStatus?.label;
  };

  return (
    <div className="mt-3 overflow-x-auto">
      <h2 className="mb-5 text-xl font-bold text-gray-900">Binuri</h2>

      <table className="mb-0 w-full border-collapse text-left text-sm font-semibold text-gray-900 [&_tbody]:divide-y [&_tbody]:divide-slate-200 [&_td]:px-4 [&_td]:py-4 [&_th]:px-4 [&_th]:py-3">
        <thead className="bg-surface-subtle text-muted">
          <tr>
            <th>Nr. BIN</th>
            <th>Client</th>
            <th>Adresa ridicare</th>
            <th>Punct ridicare</th>
            <th>Nod preluare</th>
            <th>Nod destinatie</th>
            <th>Status</th>
            <th>Data crearii</th>
            <th className="text-right">Actiuni</th>
          </tr>
        </thead>
        <tbody>
          {bins.map((b) => {
            const handleCloseBin = () => {
              dispatch(
                setSelectedCargoInternodeItemForClosing({
                  id: b.id_bin,
                  type: "BIN",
                  label: b.sn_bin,
                }),
              );
              dispatch(openClosePackageCargoInternodeRouteModal());
            };
            return (
              <tr
                key={b.id_bin}
                className="transition-colors hover:bg-surface-subtle/70">
                <td>{b.sn_bin}</td>
                <td>{b.client}</td>
                <td>{b.adresa_ridicare}</td>
                <td>{b.punct_ridicare}</td>
                <td>{b.nod_preluare}</td>
                <td>{b.nod_destinatie}</td>
                <td>
                  <span className="inline-flex rounded-control bg-info-subtle px-3 py-2 text-info">
                    {getStatusLabelForBin(b.status)}
                  </span>
                </td>
                <td>
                  <span className="inline-flex rounded-control bg-info-subtle px-3 py-2 text-info">
                    {getDateAndTime(b.data_operatie)}
                  </span>
                </td>
                <td className="text-right">
                  <ActionMenu
                    title={b.sn_bin}
                    items={[
                      {
                        id: "close-bin",
                        label: "Inchide BIN-ul",
                        icon: "CLOSE_ICON",
                        color: "error",
                        tooltip:
                          "Deschide formularul pentru inchiderea acestui BIN.",
                        onClick: handleCloseBin,
                      },
                    ]}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default BinsTable;
